export interface IIstructions {}

const spanColor = "#d4d987";

export default class Istructions implements IIstructions {
  constructor(obj: IIstructions) {
    Object.assign(this, obj);
  }

  static data = [
    {
      _id: 1,
      description: [
        "Registrati sul sito ",
        <span key={1} style={{ color: spanColor }}>
          a costo zero
        </span>,
        " e inizia subito a far scaricare l'app ai tuoi clienti.",
      ],
      transKey: "instruction1",
    },
    {
      _id: 2,
      description: [
        "Leggi il breve manuale di utilizzo e crea la tua base utenti. Segui il nostro ",
        <span key={2} style={{ color: spanColor }}>
          manuale di marketing
        </span>,
        " e sviluppa promozioni accattivanti per la tua clientela.",
      ],
      transKey: "instruction2",
    },
    {
      _id: 3,
      description: [
        "Analizza le ",
        <span key={3} style={{ color: spanColor }}>
          statistiche settimanali
        </span>,
        " di Adhesion per verificare quali promozioni sono state percepite come più interessanti dai tuoi clienti.",
      ],
      transKey: "instruction3",
    },
    {
      _id: 4,
      description: [
        "",
        <span key={4} style={{ color: spanColor }}>
          Confronta il fatturato
        </span>,
        " della tua attivit\u00E0 prima e dopo l'utilizzo di Adhesion.",
      ],
      transKey: "instruction4",
    },
  ];
}
